/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"
import { Link } from "react-router-dom"
import { brandColors } from "../../../Components/EOSThemeProvider"
import { useMediaQuery } from "@cd2/components"

interface ICustomerBreadcrumb {
  label: string
  to: string
}

export function CustomerBreadcrumbs({ breadcrumbs }: { breadcrumbs: ICustomerBreadcrumb[] }) {
  const isMobile = useMediaQuery({ maxWidth: 768 })
  return (
    <nav
      aria-label="breadcrumb"
      css={css`
        border-radius: 4px;
      `}
    >
      <div
        css={css`
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
          align-items: center;
          font-size: 16px;
          flex-wrap: wrap;
          gap: 8px;
        `}
      >
        {breadcrumbs.map((breadcrumb, index) => (
          <div
            key={index}
            css={css`
              display: flex;
              align-items: center;

              &:not(:last-child)::after {
                content: ">";
                margin: 0 0 0 8px;
                color: ${brandColors.darkNight};
                font-weight: 600;
              }
            `}
          >
            <Link
              to={breadcrumb.to}
              css={css`
                color: ${brandColors.darkNight};
                text-decoration: underline;
                font-weight: 600;

                &:hover {
                  text-decoration: underline;
                }
              `}
            >
              {breadcrumb.label}
            </Link>
          </div>
        ))}
      </div>
    </nav>
  )
}
